export default __webpack_public_path__ + "static/media/product-page-3.98f1599f.png";